// extracted by mini-css-extract-plugin
export default {"header":"Iq","fullPage":"Jq","closed":"Kq","minimize":"Lq","redcircle":"Mq","container":"Nq","text":"Oq","centered":"Pq","escapex":"Qq"};
    if(module.hot) {
      // 1711717530699
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  